import { clsx } from 'clsx';
import { Children, type ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Мелкие факты одной строкой через точку: вид · версия · паспорт.
 *
 * Два повода завести компонент. Первый: раньше каждый факт занимал свою
 * строку — ровно то, на что жаловался владелец. Второй: там, где их всё-таки
 * склеивали в subtitle у SimpleCell, хвост съедался многоточием, потому что
 * SimpleCell по умолчанию не переносит строки. Здесь перенос разрешён.
 *
 * Пустые пункты отсеиваются сами, поэтому вызывающему не нужно считать, куда
 * ставить разделитель: список полей у сущностей необязательный почти весь.
 *
 * `lead` выделяет ПЕРВЫЙ факт малиновым: в макетах так набран класс на плитке
 * реестра — по нему сетку и просматривают, а остальное дочитывают уже в
 * карточке. Выделение достаётся только первому: два акцента в строке из трёх
 * слов перестают быть акцентом.
 *
 * `tone="lilac"` красит ВСЮ строку: так набрана роль под именем участника —
 * это не факт о нём, а его место в проекте. `tone="dim"` гасит её на ступень:
 * в журнале две строки фактов подряд, и вторая — кто и когда — в макете
 * заметно тише первой, иначе они читаются одним абзацем.
 */
const TONE = {
  default: '',
  lilac: styles.metaLilac,
  dim: styles.metaDim,
};

export function Meta({
  children,
  lead = false,
  tone = 'default',
}: {
  children: ReactNode[];
  lead?: boolean;
  tone?: 'default' | 'lilac' | 'dim';
}) {
  const items = children.filter((item) => item !== null && item !== undefined && item !== false);
  if (items.length === 0) return null;

  return (
    <div className={clsx(styles.meta, TONE[tone])}>
      {Children.map(items, (item, index) => (
        <>
          {index > 0 ? <span className={styles.metaDot} /> : null}
          <span className={clsx(styles.metaItem, lead && index === 0 && styles.metaLead)}>
            {item}
          </span>
        </>
      ))}
    </div>
  );
}
